module.exports = __webpack_public_path__ + "img/mod.4de2279d.svg";